var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _vm.popupParam.seniorStatusId
                  ? _c(
                      "c-card",
                      {
                        staticClass: "cardClassDetailForm revisionLayout",
                        attrs: {
                          title: "해임정보",
                          topClass: "topcolor-orange",
                          collapsed: true,
                        },
                      },
                      [
                        _c("template", { slot: "card-detail" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-1" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "Rev",
                                        name: "revisionNum",
                                      },
                                      model: {
                                        value: _vm.data.revisionNum,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "revisionNum", $$v)
                                        },
                                        expression: "data.revisionNum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-3" },
                                  [
                                    _c("c-datepicker", {
                                      attrs: {
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        label: "해임일",
                                        name: "dismissalDate",
                                      },
                                      model: {
                                        value: _vm.data.dismissalDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.data,
                                            "dismissalDate",
                                            $$v
                                          )
                                        },
                                        expression: "data.dismissalDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-8" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "해임사유",
                                        name: "revisionContent",
                                      },
                                      model: {
                                        value: _vm.data.revisionContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.data,
                                            "revisionContent",
                                            $$v
                                          )
                                        },
                                        expression: "data.revisionContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "선임현황 기본정보" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-select" },
                      [
                        _vm.popupParam.seniorStatusId
                          ? _c("c-select", {
                              attrs: {
                                editable: !_vm.isRevision,
                                comboItems: _vm.gridrev.data,
                                type: "custom",
                                typetxt: "선임이력",
                                itemText: "revisionNum",
                                itemValue: "seniorStatusId",
                                name: "selectedseniorStatusId",
                                label: "",
                              },
                              on: { input: _vm.rowClickRev },
                              model: {
                                value: _vm.selectedseniorStatusId,
                                callback: function ($$v) {
                                  _vm.selectedseniorStatusId = $$v
                                },
                                expression: "selectedseniorStatusId",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.seniorStatusId &&
                                    !_vm.isRevision,
                                  expression:
                                    "editable && popupParam.seniorStatusId && !isRevision",
                                },
                              ],
                              attrs: {
                                label: "해임 이후 선임",
                                icon: "restart_alt",
                              },
                              on: { btnClicked: _vm.setRevision },
                            }),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.seniorStatusId &&
                                    _vm.isRevision,
                                  expression:
                                    "editable && popupParam.seniorStatusId && isRevision",
                                },
                              ],
                              attrs: { label: "취소", icon: "restart_alt" },
                              on: { btnClicked: _vm.cancelRevision },
                            }),
                            _vm.editable && _vm.popupParam.seniorStatusId
                              ? _c("c-btn", {
                                  attrs: { label: "삭제", icon: "remove" },
                                  on: { btnClicked: _vm.deleteData },
                                })
                              : _vm._e(),
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: {
                                    url: _vm.saveUrl,
                                    isSubmit: _vm.isSave,
                                    param: _vm.data,
                                    mappingType: _vm.mappingType,
                                    label: "저장",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveData,
                                    btnCallback: _vm.saveCallback,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              required: "",
                              editable: _vm.editable,
                              disabled: true,
                              afterIcon: [
                                {
                                  name: "search",
                                  click: true,
                                  callbackName: "searchSenior",
                                  color: "teal",
                                },
                                {
                                  name: "close",
                                  click: true,
                                  callbackName: "removeSenior",
                                  color: "red",
                                },
                              ],
                              label: "선해임명",
                              name: "seniorName",
                            },
                            on: {
                              searchSenior: _vm.openSenior,
                              removeSenior: _vm.removeSenior,
                            },
                            model: {
                              value: _vm.data.seniorName,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "seniorName", $$v)
                              },
                              expression: "data.seniorName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: "",
                              editable: _vm.editable,
                              type: "edit",
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.data.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "plantCd", $$v)
                              },
                              expression: "data.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-field", {
                            attrs: {
                              required: "",
                              type: "dept_user",
                              editable: _vm.editable,
                              data: _vm.data,
                              deptValue: "seniorDeptCd",
                              label: "부서 & 선임자",
                              name: "seniorUserId",
                            },
                            model: {
                              value: _vm.data.seniorUserId,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "seniorUserId", $$v)
                              },
                              expression: "data.seniorUserId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-datepicker", {
                            attrs: {
                              required: "",
                              label: "선임일",
                              start: _vm.data.seniorDate,
                              editable: _vm.editable,
                              name: "seniorDate",
                            },
                            model: {
                              value: _vm.data.seniorDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "seniorDate", $$v)
                              },
                              expression: "data.seniorDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "관련자격증",
                              name: "relatedCertificate",
                            },
                            model: {
                              value: _vm.data.relatedCertificate,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "relatedCertificate", $$v)
                              },
                              expression: "data.relatedCertificate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "자격증번호",
                              name: "certificateNo",
                            },
                            model: {
                              value: _vm.data.certificateNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "certificateNo", $$v)
                              },
                              expression: "data.certificateNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-datepicker", {
                            attrs: {
                              editable: _vm.editable,
                              label: "자격취득일",
                              name: "certificateAcquiDate",
                            },
                            model: {
                              value: _vm.data.certificateAcquiDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "certificateAcquiDate", $$v)
                              },
                              expression: "data.certificateAcquiDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
                        },
                        [
                          _c("c-multi-select", {
                            attrs: {
                              editable: _vm.editable,
                              codeGroupCd: "REGULATION_BILL_CD",
                              itemText: "codeName",
                              itemValue: "code",
                              label: "관련 법규",
                              disabled: true,
                              name: "relatedLaws",
                              maxValues: "3",
                            },
                            model: {
                              value: _vm.data.relatedLaws,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "relatedLaws", $$v)
                              },
                              expression: "data.relatedLaws",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c("c-textarea", {
                            attrs: {
                              name: "qualifiyRequire",
                              label: "자격요건",
                              disabled: true,
                              rows: 2,
                            },
                            model: {
                              value: _vm.data.qualifiyRequire,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "qualifiyRequire", $$v)
                              },
                              expression: "data.qualifiyRequire",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c("c-textarea", {
                            attrs: {
                              name: "relatedReason",
                              label: "관련근거",
                              rows: 2,
                            },
                            model: {
                              value: _vm.data.relatedReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "relatedReason", $$v)
                              },
                              expression: "data.relatedReason",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c("c-textarea", {
                            attrs: {
                              name: "seniorReason",
                              label: "수행역할",
                              rows: 2,
                            },
                            model: {
                              value: _vm.data.seniorReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "seniorReason", $$v)
                              },
                              expression: "data.seniorReason",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-table", {
                  ref: "table",
                  attrs: {
                    title: "관련 교육과정",
                    tableId: "equipmentInsp",
                    columns: _vm.grid.columns,
                    data: _vm.data.eduStatusList,
                    gridHeight: "340px",
                    filtering: false,
                    isExcelDown: false,
                    checkClickFlag: false,
                    usePaging: false,
                    rowKey: "seniorId",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "관련 선해임자료 및 자격증" },
                  },
                  [
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-12 col-md-12 col-lg-12",
                          staticStyle: { height: "280px" },
                        },
                        [
                          _c("c-upload", {
                            attrs: {
                              attachInfo: _vm.attachInfo,
                              editable: _vm.editable,
                              label: "관련 선해임자료 및 자격증",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }